// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2Q7Cv","footer":"ModalInfo_footer__1GsTT"};